import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { TradesDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingDeliveriesTradesDistrict.gridData;
export const selectDateRange = (state: RootState) => state.reportingDeliveriesTradesDistrict.dateRange;



export const selectValidParams = createSelector(
	[
		selectDateRange,
	],(
		dateRange: DateRange | null,
	) => {
		if (!dateRange) return null;
		let validParams: TradesDistrictParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
		};
		return validParams;
	}
);